// extracted by css-extract-rspack-plugin
export default {"loader":"Q9so5z9A1oqvVkID"};